import script from "./targetPage.vue?vue&type=script&setup=true&lang=js"
export * from "./targetPage.vue?vue&type=script&setup=true&lang=js"

import "./targetPage.vue?vue&type=style&index=0&id=11733c85&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11733c85"]])

export default __exports__